import { render, staticRenderFns } from "./SuperAdminAnalytics.vue?vue&type=template&id=40a05788&scoped=true&"
import script from "./SuperAdminAnalytics.vue?vue&type=script&lang=js&"
export * from "./SuperAdminAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./SuperAdminAnalytics.vue?vue&type=style&index=0&id=40a05788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a05788",
  null
  
)

export default component.exports